import { render, staticRenderFns } from "./AtendimentosPorPessoa.vue?vue&type=template&id=72c3aea2"
import script from "./AtendimentosPorPessoa.vue?vue&type=script&lang=js"
export * from "./AtendimentosPorPessoa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports